/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_409Inputs */

const en_api_error_409 = /** @type {(inputs: Api_Error_409Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A conflict occurred with an existing resource.`)
};

const pt_br2_api_error_409 = /** @type {(inputs: Api_Error_409Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um conflito com um recurso existente.`)
};

/**
* | output |
* | --- |
* | "A conflict occurred with an existing resource." |
*
* @param {Api_Error_409Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_409 = /** @type {((inputs?: Api_Error_409Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_409Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_409(inputs)
	return pt_br2_api_error_409(inputs)
});